import url from '../url.json';
import config from '../config.json';
import axios from '../utils/axiosInstance';
import {
  sendNewNodeMessage,
  sendNewEdgeMessage,
  sendNewChatRoomMessage,
} from '../utils/socketTool';
// 定義每個群組對應的顏色
const colorMap = {
  idea: { border: '#FFFFCC', background: '#FFFFCC' },         // 淡黃色
  info: { border: '#CCFFCC', background: '#CCFFCC' },        // 淡綠色
  question: { border: '#CCCCFF', background: '#CCCCFF' },     // 淡藍色
  experiment: { border: '#FFDBDB', background: '#FFDBDB' },    // 淺紅色
  record: { border: '#B9DCF4', background: '#B9DCF4' },        // 淺藍色
  reply: { border: '#FFFFFF', background: '#FFFFFF' },         // 白色
  // 可以在此添加更多群組及其顏色
};

// 默認顏色
const defaultColor = { border: '#CCCCCC', background: '#EEEEEE' };

export const newNode = async (ideaData, activityId, ws) => {
  console.log('🎯 [newNode] 開始創建節點');
  console.log('  - ideaData:', ideaData);
  console.log('  - activityId:', activityId);
  console.log('  - ws:', !!ws);
  
  const isAnnouncement = ideaData.content.includes('【公告】'); // 判斷是否為公告

  return axios
    .post(url.backendHost + config.createWallNode, ideaData)
    .then((response) => {
      console.log('✅ [newNode] 新增節點成功，準備 ws.emit create-node');
      console.log('  - 後端響應:', response.data);
      
      // 修正：後端返回的數據結構是 response.data.data
      const nodeData = response.data.data || response.data.node;
      
      if (ws && activityId) {
        const wsData = {
          ...nodeData,
          ...ideaData,
          id: nodeData.id,
          createdAt: nodeData.created_at || nodeData.createdAt,
          activityId: activityId,
          course_dispatch_id: activityId, // 添加 course_dispatch_id 以確保後端能正確廣播
        };
        console.log('📡 [newNode] 準備廣播數據:', wsData);
        ws.emit('create-node', wsData);
        console.log('✅ [newNode] WebSocket 廣播已發送');
      } else {
        console.warn('⚠️ [newNode] WebSocket 或 activityId 不存在，無法廣播');
      }
      
      // 如果是公告，則發送公告專用事件
      if (isAnnouncement && ws && activityId) {
        ws.emit('announcement', {
          ...ideaData,
          id: nodeData.id,
          createdAt: nodeData.created_at || nodeData.createdAt,
        });
        console.log('📢 [newNode] 公告廣播已發送');
      }
      return response;
    })
    .catch((error) => {
      console.error('❌ [newNode] 創建節點失敗');
      console.error('  - 錯誤信息:', error.message);
      console.error('  - 完整錯誤:', error);
      throw error;
    });
};

export const newEdge = async (edgeData, activityId, ws) => {
  console.log('🔗 [newEdge] 準備創建邊緣');
  console.log('  - 完整數據:', edgeData);
  console.log('  - from_node_id:', edgeData.from_node_id);
  console.log('  - to_node_id:', edgeData.to_node_id);
  console.log('  - group_id:', edgeData.group_id);
  console.log('  - course_dispatch_id:', edgeData.course_dispatch_id);
  
  return axios
    .post(url.backendHost + config.createNodeEdge, edgeData)
    .then((response) => {
      console.log('✅ [newEdge] 邊緣創建成功');
      console.log('  - 後端響應:', response.data);
      console.log('  - 邊緣 ID:', response.data.data?.id);
      
      if (ws && activityId) {
        const wsData = {
          ...edgeData,
          id: response.data.data?.id,
          activityId: activityId,
          course_dispatch_id: activityId, // 添加 course_dispatch_id 以確保後端能正確廣播
        };
        console.log('📡 [newEdge] 準備 WebSocket 廣播');
        console.log('  - 廣播數據:', wsData);
        console.log('  - activityId:', activityId);
        
        sendNewEdgeMessage(ws, wsData);
        console.log('✅ [newEdge] WebSocket 廣播已發送');
      } else {
        console.warn('⚠️ [newEdge] WebSocket 或 activityId 不存在');
        console.warn('  - ws:', !!ws);
        console.warn('  - activityId:', activityId);
      }
      
      return response;
    })
    .catch((error) => {
      console.error('❌ [newEdge] 創建邊緣失敗');
      console.error('  - 錯誤信息:', error.message);
      console.error('  - 完整錯誤:', error);
      throw error;
    });
};
function getEmoji(tag) {
  switch (tag) {
    case 'idea': {
      return '💡';
    }
    case 'info': {
      return '🔍';
    }
    case 'question': {
      return '❓';
    }
    case 'experiment': {
      return '🧪';
    }
    case 'record': {
      return '📄';
    }
    case 'reply': {
      return '💡';
    }
  }
}

const formatTimestamp = (timestamp) => {
  return new Intl.DateTimeFormat('en-US', {
    // year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    //   second: 'numeric',
    hour12: false,
  }).format(new Date(timestamp));
};

export const genEdge = (edgeData) => {
  // console.log(`ideaTool:genEdge:edgeData `, edgeData);
  return {
    from: edgeData.from,
    to: edgeData.to,
  };
};

export const genNode = (ideaData) => {
  const color = colorMap[ideaData.tags] || defaultColor;
  const isAnnouncement = ideaData.content.includes('【公告】'); // 判斷是否為公告
  
  // A-4: 想法貼以標題為主，作者跟時間縮小
  // 使用 HTML 標籤來控制字體大小（vis-network 支援 HTML，需要設置 font.multi = true）
  const node = {
    id: String(ideaData.id), // 確保 ID 是字串
    label:
      getEmoji(ideaData.tags) +
      '\n\n' +
      `<span style="font-size: 18px; font-weight: bold; line-height: 1.3;">${ideaData.title || '無標題'}</span>` +
      '\n\n' +
      `<span style="font-size: 11px; color: #666; line-height: 1.2;">${ideaData.author || '匿名'}</span>` +
      '\n' +
      `<span style="font-size: 9px; color: #999; line-height: 1;">${formatTimestamp(ideaData.createdAt)}</span>`,
    title: ideaData.content,
    group: ideaData.tags,
    color: color, // 添加 color 屬性
    borderWidth: 1, // 默認邊框寬度
    isAnnouncement,
    font: {
      multi: true, // 啟用 HTML/multi-line 標籤支援（vis-network 需要設為 true）
      size: 14, // 基礎字體大小（實際大小由 HTML 中的 style 控制）
    }
  };

  console.log('genNode:', node); // 調試用
  return node;
};

export const newMessage = async (messageData, ws) => {
  return axios
    .post(url.backendHost + config.createMessage, messageData)
    .then((response) => {
      console.log('newMessage');
      console.log(response.data.chatRoomMessage);
      sendNewChatRoomMessage(ws, messageData);
      console.log('sendNewChatRoomMessage');
      return response;
    });
};
